import ProductDetailContainer from './ProductDetailContainer';
export default ProductDetailContainer;
